// router/index.js
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import store from '@/store';
import DeliveryDetail from '@/views/appLivraisons/DeliveryDetail.vue'
import ShopDeliveryDetail from '@/views/appLivraisons/ShopDeliveryDetail.vue'
import MyTournee from '../views/appLivraisons/MyTournee.vue';
import DepartLivreur from '../views/admin/departMatin/DepartLivreur/DepartLivreur.vue';
import prepaPalettes from '../views/admin/departMatin/PrepaPalette.vue';   
import PrimeOverview from '../views/livreurs/PrimeOverview.vue'; 



const routes = [
    {
        path: '/',
        component: AppLayout,
        children: [
            {
                path: '/',
                name: 'dashboard',
                meta: {
                    requiresAuth: true,
                    // Cette route sera utilisée comme page d'accueil par défaut
                    isDefault: true,
                    // Tous les rôles peuvent y accéder, chacun étant redirigé vers sa version appropriée
                    role: ['Admin', 'Client', 'Delivery', 'Preparator']
                },
                component: DepartLivreur
            },
            {
                path: '/profil',
                name: 'profil',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Client', 'Delivery']
                },
                component: () => import('@/views/profil/Profil.vue')
            },            
            {
                path: '/prepaPalettes',
                name: 'prepa-palettes',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: prepaPalettes
            },
            {
                path: '/controlePalettes',
                name: 'controle-palettes',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: () => import('@/views/admin/departMatin/ControlePalette.vue')
            },
            {
                path: '/myTournee',
                name: 'my-tournee',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: MyTournee
            },
            {
                path: '/delivery/:id',
                name: 'delivery-detail',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: DeliveryDetail
            },
            {
                path: '/shop-delivery/:id',
                name: 'shop-delivery-detail',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: ShopDeliveryDetail
            },
            {
                path: '/prime',
                name: 'prime',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: PrimeOverview
            },
            {
                path: '/primes-v2',
                name: 'primes-v2',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: () => import('@/views/livreurs/MyPrimesV2/MyPrimesView.vue')
            },
            {
                path: '/primes-livreurs',
                name: 'primes-livreurs',
                meta: {
                    requiresAuth: true,
                    role: ['Admin']
                },
                component: () => import('@/views/admin/Livreurs/primes/LivreursPrimesList.vue')
            },
            {
                path: '/departLivreur',
                name: 'depart-livreur',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: DepartLivreur
            },
            {
                path: '/ambassadeur',
                name: 'ambassadeur',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: () => import('@/views/appLivraisons/ambassadeur/Ambassadeur.vue')
            },
            {
                path: '/app-livraisons/ambassadeur/prospect-coordinates',
                name: 'prospect-coordinates',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: () => import('@/views/appLivraisons/ambassadeur/components/ProspectCoordinates.vue')
            },
            {
                path: '/app-livraisons/ambassadeur/report-competitor',
                name: 'report-competitor',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: () => import('@/views/appLivraisons/ambassadeur/components/ReportCompetitor.vue')
            },
            {
                path: '/app-livraisons/ambassadeur/my-prospects',
                name: 'my-prospects',
                meta: {
                    requiresAuth: true,
                    role: ['Admin', 'Delivery', 'Preparator']
                },
                component: () => import('@/views/appLivraisons/ambassadeur/components/MyProspects.vue')
            }
        ]
    },
    {
        path: '/pages/notfound',
        name: 'notfound',
        component: () => import('@/views/pages/NotFound.vue')
    },
    {
        path: '/auth/login',
        name: 'login',
        component: () => import('@/views/pages/auth/Login.vue')
    },
    {
        path: '/auth/access',
        name: 'accessDenied',
        component: () => import('@/views/pages/auth/Access.vue')
    },
    {
        path: '/auth/error',
        name: 'error',
        component: () => import('@/views/pages/auth/Error.vue')
    },
    {
        path: '/auth/forgotpassword',
        name: 'forgotpassword',
        component: () => import('@/views/pages/auth/ForgotPassword.vue')
    },
    {
        path: '/auth/newpassword',
        name: 'newpassword',
        component: () => import('@/views/pages/auth/NewPassword.vue')
    },
    {
        path: '/auth/verification',
        name: 'verification',
        component: () => import('@/views/pages/auth/Verification.vue')
    },
    {
        path: '/auth/lockscreen',
        name: 'lockscreen',
        component: () => import('@/views/pages/auth/LockScreen.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/pages/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
});

// Fonction pour trouver la première route autorisée pour un rôle donné
const findFirstAuthorizedRoute = (role) => {
    if (!role) return null;
    
    // Parcourir toutes les routes pour trouver la première autorisée pour ce rôle
    for (const route of routes) {
        if (route.path === '/') { 
            // Pour les routes enfants du layout principal
            for (const childRoute of route.children) {
                if (childRoute.meta && 
                    childRoute.meta.requiresAuth && 
                    childRoute.meta.role && 
                    childRoute.meta.role.includes(role) &&
                    childRoute.path !== '/') {
                    return childRoute;
                }
            }
        }
    }
    
    return null;
};

// Guard global pour protéger les routes et rediriger en fonction du rôle
router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated;
    const userRole = localStorage.getItem('role');

    // Si la route nécessite une authentification et que l'utilisateur n'est pas authentifié
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        // Rediriger vers la page de login
        next({ name: 'login' });
        return;
    }
    
    // Si l'utilisateur est authentifié et tente d'accéder à une route protégée par rôle
    if (isAuthenticated && to.meta && to.meta.role) {
        // Vérifier si le rôle de l'utilisateur est autorisé pour cette route
        if (!to.meta.role.includes(userRole)) {
            // Si non autorisé, trouver la première route autorisée pour ce rôle
            const firstAuthorizedRoute = findFirstAuthorizedRoute(userRole);
            
            if (firstAuthorizedRoute) {
                // Rediriger vers la première route autorisée
                next({ path: firstAuthorizedRoute.path });
            } else {
                // Si aucune route autorisée n'est trouvée, rediriger vers la page d'accès refusé
                next({ name: 'accessDenied' });
            }
            return;
        }
    }
    
    // Si l'utilisateur est authentifié et accède à la racine '/'
    if (isAuthenticated && to.path === '/') {
        // La redirection est déjà configurée dans la route '/'
        next();
        return;
    }

    // Sinon, continuer normalement
    next();
});

// Update the beforeResolve guard to handle different delivery types
router.beforeResolve(async (to, from, next) => {
    // Handle both delivery types
    if ((to.name === 'delivery-detail' || to.name === 'shop-delivery-detail') && to.params.id) {
        const deliveryId = to.params.id;
        
        try {
            // Check if we already have this delivery in store
            if (store.state.currentDelivery?.id !== deliveryId) {
                // Try to preload the delivery data based on route
                if (to.name === 'shop-delivery-detail') {
                    await store.dispatch('sync/getShopDelivery', deliveryId)
                        .then(deliveryData => {
                            if (deliveryData) {
                                store.commit('SET_CURRENT_DELIVERY', deliveryData);
                            }
                        })
                        .catch(error => {
                            console.warn('Could not preload shop delivery data:', error);
                        });
                } else {
                    await store.dispatch('sync/getDelivery', deliveryId)
                        .then(deliveryData => {
                            if (deliveryData) {
                                store.commit('SET_CURRENT_DELIVERY', deliveryData);
                            }
                        })
                        .catch(error => {
                            console.warn('Could not preload delivery data:', error);
                        });
                }
            }
            next();
        } catch (error) {
            console.error('Error in beforeResolve:', error);
            next(); // Continue anyway, the component will handle the error
        }
    } else {
        next();
    }
});

export default router;